import { useMemo } from 'react';
import type { EnrichedElasticSearchResponseFacet } from '@//utils/vehicles-search/useEnrichedFacets';
import { hasValidLocationInParams } from '@//utils/vehicles-search/utils';

interface UseActiveFacets {
  enrichedFacets?: EnrichedElasticSearchResponseFacet[];
  searchParams: URLSearchParams;
}

const useActiveFacets = ({ enrichedFacets, searchParams }: UseActiveFacets) => {
  const activeFacets = useMemo(
    () =>
      enrichedFacets?.filter((f) => {
        if (f.id === 'location') {
          return hasValidLocationInParams(searchParams);
        }
        const hasDiscrete = searchParams.getAll(f.id).length > 0;
        const hasMin = searchParams.has(`${f.id}.min`);
        const hasMax = searchParams.has(`${f.id}.max`);
        return hasDiscrete || hasMin || hasMax;
      }),
    [searchParams.toString(), enrichedFacets],
  );

  return activeFacets;
};

export default useActiveFacets;
